import * as core from '../../../../../../../core'

import { query } from './requirements-dashboard-assignee-bar.query'

export const RESOURCE = {
  payload: {
    alias: 'requirements-dashboard.assignee-bar',
    description:
      'Requirement count per assigned employee, click a bar to filter the table below',
    name: 'Requirements Dashboard - Assignee Bar',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
